import config from "config/config";
import HandleApiResponse from "utils/handleApiResponse";

const vraRadPoolAPI = () => {
    const { handleResponse, handleError } = HandleApiResponse();

    async function getAllVraRadPoolAPI(values) {
      const userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
        try {
          const obj = {
            method: "GET",
            credentials: "include",
            headers: {
              "Content-Type": "application/json",
              "User-Timezone": userTimeZone
            },
          };
          const query = JSON.stringify(values);
          const res = await fetch(
            `${config.host}/panel/rp/vra-rad-mapping?query=${query}`,
            obj
          );
          return handleResponse(res);
        } catch (err) {
          handleError(err);
        }
      }

      async function getAllVraRosterAPI(values) {
        try {
          const obj = {
            method: "GET",
            credentials: "include",
            headers: {
              "Content-Type": "application/json",
            },
          };
          const query = JSON.stringify(values);
          const res = await fetch(
           `${config.host}/panel/rp/vraRoster/allVraRosterIds`,
            obj
          );
          return handleResponse(res);
        } catch (err) {
          handleError(err);
        }
      } 

      async function updateVraRadPoolAPI(value) {
        try {
          const obj = {
            method: "PUT",
            credentials: "include",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify(value),
          };
          const res = await fetch(
            `${config.host}/panel/rp/vra-rad-mapping`,
            obj
          );
          return handleResponse(res);
        } catch (err) {
          handleError(err);
        }
      }

      async function getVraNeededWarningCountAPI() {
          try {
            const obj = {
              method: "GET",
              credentials: "include",
              headers: {
                "Content-Type": "application/json",
              },
            };
            const res = await fetch(
              `${config.host}/panel/rp/vra-rad-mapping/vra-needed-warning-count`,
              obj
            );
            return handleResponse(res);
          } catch (err) {
            handleError(err);
          }
        }

        async function getAllVraNeededWarningAPI(values) {
          const userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
            try {
              const obj = {
                method: "GET",
                credentials: "include",
                headers: {
                  "Content-Type": "application/json",
                  "User-Timezone": userTimeZone
                },
              };
              const query = JSON.stringify(values);
              const res = await fetch(
                `${config.host}/panel/rp/vra-rad-mapping/vra-needed-warning?query=${query}`,
                obj
              );
              return handleResponse(res);
            } catch (err) {
              handleError(err);
            }
          }
    
    return{
        getAllVraRadPoolAPI,
        getAllVraRosterAPI,
        updateVraRadPoolAPI,
        getVraNeededWarningCountAPI,
        getAllVraNeededWarningAPI
    }
}
export default vraRadPoolAPI;
